// src/Landing.js
import { useNavigate } from 'react-router-dom';
import './Landing.css';

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="landing-container">
      <div className="landing-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      {/* Navigation */}
      <nav className="landing-nav">
        <div className="nav-logo">
          <img src="/favicon.ico" alt="Logo" style={{ width: '24px', height: '24px' }} />
          <span>Costly Cure</span>
        </div>
        <div className="nav-buttons">
          <button className="nav-btn nav-btn-secondary" onClick={() => navigate('/login')}>
            Sign In
          </button>
          <button className="nav-btn nav-btn-primary" onClick={() => navigate('/signup')}>
            Play Now
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-badge">🩺 Medical Diagnosis Game</div>
          <h1 className="hero-title">
            Can You Diagnose <span className="gradient-text">Without Going Broke?</span>
          </h1>
          <p className="hero-subtitle">
            Play as a doctor. Order tests wisely — every test costs you money, but every correct
            diagnosis earns it back. The fewer unnecessary tests you order, the more you keep.
            How good is your clinical judgment?
          </p>
          <div className="hero-actions">
            <button className="hero-cta-btn" onClick={() => navigate('/signup')}>
              Start Playing Free
            </button>
            <button className="hero-secondary-btn" onClick={() => navigate('/login')}>
              Sign In
            </button>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="features-section">
        <h2 className="section-title">How It Works</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">📋</div>
            <h3>Review the Patient</h3>
            <p>Read the chief complaint, medical history, vitals, and physical exam findings for each patient.</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🔬</div>
            <h3>Order Tests Wisely</h3>
            <p>Choose from available tests. Each test costs real in-game money.</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🧠</div>
            <h3>Make Your Diagnosis</h3>
            <p>Pick from multiple diagnosis options. Correct answers earn you back your test costs plus a bonus.</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">💰</div>
            <h3>Grow Your Balance</h3>
            <p>Unrelated tests drain your wallet with no benefit. Efficient doctors earn more.</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-card">
          <h2>Ready to Test Your Diagnostic Skills?</h2>
          <p>Sign up free and start diagnosing patients. How much can you earn?</p>
          <button className="cta-btn" onClick={() => navigate('/signup')}>
            Create Free Account
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/favicon.ico" alt="Logo" style={{ width: '24px', height: '24px' }} />
            <span>Costly Cure</span>
          </div>
          <div className="footer-links">
            <a href="/terms">Terms of Service</a>
            <a href="/privacy">Privacy Policy</a>
          </div>
          <p className="footer-copyright">&copy; {new Date().getFullYear()} CostlyCure. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
